import { render, staticRenderFns } from "./customFooter.vue?vue&type=template&id=2c7adfd4"
import script from "./customFooter.vue?vue&type=script&lang=js"
export * from "./customFooter.vue?vue&type=script&lang=js"
import style0 from "./customFooter.vue?vue&type=style&index=0&id=2c7adfd4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports